import GroupServicesDialog from './_GroupServicesDialog';

export default GroupServicesDialog;
